"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSummarySupported = exports.setBuildRef = exports.setInputs = exports.setTmpDir = exports.isSummarySupported = exports.buildRef = exports.inputs = exports.tmpDir = void 0;
const core = __importStar(require("@actions/core"));
const context_1 = require("./context");
exports.tmpDir = process.env['STATE_tmpDir'] || '';
exports.inputs = process.env['STATE_inputs'] ? JSON.parse(process.env['STATE_inputs']) : undefined;
exports.buildRef = process.env['STATE_buildRef'] || '';
exports.isSummarySupported = !!process.env['STATE_isSummarySupported'];
function setTmpDir(tmpDir) {
    core.saveState('tmpDir', tmpDir);
}
exports.setTmpDir = setTmpDir;
function setInputs(inputs) {
    core.saveState('inputs', JSON.stringify((0, context_1.sanitizeInputs)(inputs)));
}
exports.setInputs = setInputs;
function setBuildRef(buildRef) {
    core.saveState('buildRef', buildRef);
}
exports.setBuildRef = setBuildRef;
function setSummarySupported() {
    core.saveState('isSummarySupported', 'true');
}
exports.setSummarySupported = setSummarySupported;
